import Vue from "vue";
import { store } from "./store/";
import Parse from "@/main.js";

// replace g_getValue, g_getNote, g_getPlaceholder with this function
Vue.prototype.g_getSurveyFieldStuffWithThisPrefix = function(
  object,
  current_language,
  prefix,
  languages
) {
  var english_holder = "";
  var pashto_holder = "";
  var dari_holder = "";
  if (prefix == "Label" || prefix == "Note") {
    english_holder = "english" + prefix;
    pashto_holder = "pashto" + prefix;
    dari_holder = "dari" + prefix;
  } else if (prefix == "Placeholder") {
    english_holder = "fieldEnglish" + prefix;
    pashto_holder = "fieldPashto" + prefix;
    dari_holder = "fieldDari" + prefix;
  }

  // dari
  if (current_language == "dari") {
    if (languages.includes("dari")) {
      if (prefix == "Placeholder") {
        return object[dari_holder];
      } else {
        if (object[dari_holder]) {
          return object[dari_holder];
        } else {
          return object[pashto_holder] || object[english_holder];
        }
      }
    } else {
      return object[pashto_holder] || object[english_holder];
    }

    // pashto
  } else if (current_language == "pashto") {
    if (languages.includes("pashto")) {
      if (prefix == "Placeholder") {
        return object[pashto_holder];
      } else {
        if (object[pashto_holder]) {
          return object[pashto_holder];
        } else {
          return object[dari_holder] || object[english_holder];
        }
      }
    } else {
      return object[dari_holder] || object[english_holder];
    }
    // english
  } else if (current_language == "english") {
    if (languages.includes("english")) {
      if (prefix == "Placeholder") {
        return object[english_holder];
      } else {
        if (object[english_holder]) {
          return object[english_holder];
        } else {
          return object[pashto_holder] || object[dari_holder];
        }
      }
    } else {
      return object[pashto_holder] || object[dari_holder];
    }
  }
};

Vue.prototype.g_localTranslator = function(word, language) {
  if (language == "english") {
    if (word == "province") {
      return "Province";
    } else if (word == "district") {
      return "District";
    } else if (word == "polling center") {
      return "Polling Center";
    } else if (word == "latitude") {
      return "Latitude";
    } else if (word == "longitude") {
      return "Longitude";
    } else if (word == "english") {
      return "English";
    }
  } else if (language == "pashto") {
    if (word == "province") {
      return "ولایت";
    } else if (word == "district") {
      return "ولسوالی";
    } else if (word == "polling center") {
      return "د رای ورکولو مرکز";
    } else if (word == "latitude") {
      return "عرض البلد";
    } else if (word == "longitude") {
      return "طول البلد";
    } else if (word == "pashto") {
      return "پښتو";
    }
  } else if (language == "dari") {
    if (word == "province") {
      return "ولایت";
    } else if (word == "district") {
      return "ولسوالی";
    } else if (word == "polling center") {
      return "مرکز رای دهی";
    } else if (word == "latitude") {
      return "عرض البلد";
    } else if (word == "longitude") {
      return "طول البلد";
    } else if (word == "dari") {
      return "دری";
    }
  }
};

Vue.prototype.g_userHasSubmission = async function(form, user) {
  if (user && form) {
    if (form.get("status") != "pending" && form.get("class_name")) {
      var q = new Parse.Query(form.get("class_name"));
      q.equalTo("createdBy", user);
      var count = await q.count();
      if (count != 0) return true;
    }
  }
  return false;
};

Vue.prototype.g_isFormDesignApprover = function(form) {
  var user = store.getters.user;
  if (user && form) {
    if (form.get("survey_design_approvers")) {
      for (let i = 0; i < form.get("survey_design_approvers").length; i++) {
        const approver = form.get("survey_design_approvers")[i];
        if (approver) {
          if (user.id == approver.id) return true;
        }
      }
    }
  }
  return false;
};

Vue.prototype.g_canEditForm = function(form) {
  var user = store.getters.user;
  if (user && form && form.get("department") != null) {
    if (!user.get("roles").includes("admin")) {
      if (user.get("departments")) {
        for (let i = 0; i < user.get("departments").length; i++) {
          const user_department = user.get("departments")[i];
          if (form.get("department").id == user_department.id) return true;
        }
      }
    }
  }
  return false;
};

Vue.prototype.g_checkIfUserIsAdminOrManagerByRole = function() {
  var user_roles = store.getters.getUserRolesFromState;
  if (store.getters.user && user_roles) {
    for (let i = 0; i < user_roles.length; i++) {
      const role = user_roles[i];
      if (role.get("name") == "admin" || role.get("name") == "manager") {
        return role.get("name");
      }
    }
  }
  return false;
};

Vue.prototype.g_checkUserRole = function() {
  var user_roles = store.getters.getUserRolesFromState;
  var detected_user_type = "";
  if (store.getters.user && user_roles) {
    for (let i = 0; i < user_roles.length; i++) {
      const role = user_roles[i];
      if (role.get("name") == "admin") {
        detected_user_type = "admin";
      } else if (role.get("name") == "manager") {
        detected_user_type = "manager";
      } else if (role.get("name") == "guest") {
        detected_user_type = "guest";
      } else if (
        role.get("name") != "admin" &&
        role.get("name") != "manager" &&
        role.get("name") != "guest"
      ) {
        return "role-based";
      }
    }
  }
  return detected_user_type;
};

Vue.prototype.sendEmail = function(data) {
  Email.send({
    Host: "smtp.mailgun.org",
    Username: "postmaster@mailer.speensoft.net",
    Password: "2c1fef14f0294c340a5eb1ca63c55240-39bc661a-8ea05248",
    To: data.to,
    From: "neis@nepa.gov.af",
    Subject: data.subject,
    Body: data.text
  })
    .then(message => {
      this.$notify({
        group: "foo",
        text: this._("Link was sent to your email"),
        duration: 4000,
        position: "top left",
        type: "success"
      });
    })
    .catch(e => {
      this.$notify({
        group: "foo",
        title: this._("System Error"),
        text: this._("An error was sending link to your email"),
        duration: 4000,
        position: "top left",
        type: "error"
      });
    });
};

Vue.prototype._translateWithLocalLanguage = function(txt, language) {
  if (txt != undefined && txt != null) {
    let txt_small = txt.toLowerCase();
    let strings = window.strings;

    if (language == "pashto") {
      return strings[txt_small] ? strings[txt_small][0] : txt;
    } else if (language == "dari") {
      return strings[txt_small] ? strings[txt_small][1] : txt;
    } else return txt;
  } else return "";
};

Vue.prototype._ = function(txt) {
  if (txt != undefined && txt != null) {
    let txt_small = txt.toLowerCase();
    let strings = window.strings;

    if (store.getters.getSystemLanguage == "pashto") {
      return strings[txt_small] ? strings[txt_small][0] : txt;
    } else if (store.getters.getSystemLanguage == "dari") {
      return strings[txt_small] ? strings[txt_small][1] : txt;
    } else return txt;
  } else return "";
};

Vue.prototype.g_getLabel = function(obj) {
  if (obj == null) return "n/a";
  if (store.getters.getSystemLanguage == "dari") {
    if (obj.get("label_dari") != "") return obj.get("label_dari");
    else if (obj.get("label_pashto") != "") return obj.get("label_pashto");
    else return obj.get("label_english");
  } else if (store.getters.getSystemLanguage == "pashto") {
    if (obj.get("label_pashto") != "") return obj.get("label_pashto");
    else if (obj.get("label_dari") != "") return obj.get("label_dari");
    else return obj.get("label_english");
  } else if (store.getters.getSystemLanguage == "english") {
    if (obj.get("label_english") != "") return obj.get("label_english");
    else if (obj.get("label_pashto") != "") return obj.get("label_pashto");
    else return obj.get("label_dari");
  }
};

Vue.prototype.slugToObject = async function(slug, className) {
  let fetchedObject = null;
  let query = new Parse.Query(className);
  query.equalTo("slugified", slug);
  return await query.first();
};

Vue.prototype.g_fetchObject = async function(id, className) {
  var query = new Parse.Query(className);
  let fetchedObject = await query.get(id);
  return fetchedObject;
};

Vue.prototype.g_approveObject = async function(payload) {
  var reference_id = "";
  var englishLabel = "";
  var pashtoLabel = "";
  var dariLabel = "";
  var to = null;

  if (
    payload.className == "Form" ||
    payload.className == "Article" ||
    payload.className == "File" ||
    payload.className == "Map"
  ) {
    reference_id = payload.id;
  } else if (payload.className.includes("Data_")) {
    if (payload.get("form")) reference_id = payload.get("form").id;
  }
  if (payload.className.includes("Data_")) {
    to = payload.get("createdBy");
    let q = new Parse.Query("Form");
    q.equalTo("class_name", payload.className);
    let result = await q.first();
    if (result) {
      englishLabel = result.get("label_english");
      pashtoLabel = result.get("label_pashto");
      dariLabel = result.get("label_dari");
    }
  } else {
    englishLabel = payload.get("label_english");
    pashtoLabel = payload.get("label_pashto");
    dariLabel = payload.get("label_dari");
  }
  let categoryId;
  if (store.getters.getCurrentCategory) {
    categoryId = store.getters.getCurrentCategory.id;
  } else
    categoryId = payload.get("category") ? payload.get("category").id : null;

  return new Promise((resolve, reject) => {
    if (categoryId == null) {
      reject("category does not exists.");
      return;
    }
    var self = this;
    self.VaModal.confirm({
      title: self._("Alert"),
      message: self._(
        "Please make sure if you want to approve the selected " +
          payload.className.toLowerCase() +
          ". Remember to save the latest before approving"
      ),
      type: "warning",
      onConfirm() {
        self.$store.commit("setLoading", true);
        if (payload.className == "Form")
          payload.set("survey_design_status", "approved");
        else payload.set("status", "approved");
        payload.set("approvalBy", makePointer("User", self.user.id));
        payload
          .save()
          .then(async updated => {
            self.$store.commit("setLoading", false);
            self.$notify({
              group: "foo",
              text: self._(payload.className + " was approved"),
              duration: 4000,
              position: "top left",
              type: "success"
            });
            var url;
            if (store.state.shared.router.currentRoute.name == "surveysList") {
              url =
                store.state.shared.router.currentRoute.path +
                "/form/" +
                payload.id;
            } else url = store.state.shared.router.currentRoute.path;

            Vue.prototype.g_newActivity({
              label_english: englishLabel,
              label_pashto: pashtoLabel,
              label_dari: dariLabel,
              type: store.state.shared.router.currentRoute.matched[0].name.substring(
                0,
                store.state.shared.router.currentRoute.matched[0].name.length -
                  1
              ),
              action: "approve",
              url: url,
              createdBy: store.state.auth.user.id,
              to: to,
              class: payload.className,
              category: payload.get("category"),
              department: payload.get("department"),
              reference_id: reference_id
            });
            resolve(updated);
          })
          .catch(e => {
            self.$store.commit("setLoading", false);
            self.$notify({
              group: "foo",
              text: self._(
                "There was some problem while approving " +
                  payload.className.toLowerCase()
              ),
              duration: 4000,
              position: "top left",
              type: "error"
            });
            reject(e);
          });
      }
    });
  });
};

Vue.prototype.g_rejectObject = async function(payload) {
  var reference_id = "";
  var englishLabel = "";
  var pashtoLabel = "";
  var dariLabel = "";
  var to = null;

  if (
    payload.className == "Form" ||
    payload.className == "Article" ||
    payload.className == "File" ||
    payload.className == "Map"
  ) {
    reference_id = payload.id;
  } else if (payload.className.includes("Data_")) {
    if (payload.get("form")) reference_id = payload.get("form").id;
  }

  if (payload.className.includes("Data_")) {
    to = payload.get("createdBy");
    let q = new Parse.Query("Form");
    q.equalTo("class_name", payload.className);
    let result = await q.first();
    if (result) {
      englishLabel = result.get("label_english");
      pashtoLabel = result.get("label_pashto");
      dariLabel = result.get("label_dari");
    }
  } else {
    englishLabel = payload.get("label_english");
    pashtoLabel = payload.get("label_pashto");
    dariLabel = payload.get("label_dari");
  }

  let categoryId;
  if (store.getters.getCurrentCategory) {
    categoryId = store.getters.getCurrentCategory.id;
  } else
    categoryId = payload.get("category") ? payload.get("category").id : null;
  return new Promise((resolve, reject) => {
    if (categoryId == null) {
      reject("category does not exists.");
      return;
    }

    var self = this;
    self.VaModal.confirm({
      title: self._("Alert"),
      message: self._(
        "Please make sure if you want to reject the selected " +
          payload.className.toLowerCase()
      ),
      type: "warning",
      onConfirm() {
        self.$store.commit("setLoading", true);
        if (payload.className == "Form")
          payload.set("survey_design_status", "rejected");
        else payload.set("status", "rejected");
        payload.set("approvalBy", makePointer("User", self.user.id));
        payload
          .save()
          .then(async updated => {
            self.$store.commit("setLoading", false);
            self.$notify({
              group: "foo",
              text: self._(payload.className + " was rejected"),
              duration: 4000,
              position: "top left",
              type: "warn"
            });
            var url;
            if (store.state.shared.router.currentRoute.name == "surveysList") {
              url =
                store.state.shared.router.currentRoute.path +
                "/form/" +
                payload.id;
            } else url = store.state.shared.router.currentRoute.path;

            Vue.prototype.g_newActivity({
              label_english: englishLabel,
              label_pashto: pashtoLabel,
              label_dari: dariLabel,
              type: store.state.shared.router.currentRoute.matched[0].name.substring(
                0,
                store.state.shared.router.currentRoute.matched[0].name.length -
                  1
              ),
              action: "reject",
              url: url,
              createdBy: store.state.auth.user.id,
              to: to,
              category: payload.get("category"),
              department: payload.get("department"),
              class: payload.className,
              reference_id: reference_id
            });

            resolve(updated);
          })
          .catch(e => {
            reject(e);
            self.$store.commit("setLoading", false);
            self.$notify({
              group: "foo",
              text: self._(
                "There was some problem while rejecting " +
                  payload.className.toLowerCase()
              ),
              duration: 4000,
              position: "top left",
              type: "error"
            });
          });
      }
    });
  });
};

Vue.prototype.deleteFilters = async function(payload) {
  let full_route = store.state.shared.router.currentRoute.path;
  let route_name = store.state.shared.router.currentRoute.matched[0].name;
  let type = route_name.substring(0, route_name.length - 1);
  let activity_category =
    payload.className == "Form" ? payload.get("category") : payload;
  let filter_url =
    payload.className == "Form"
      ? full_route + "/" + payload.get("class_name").slice(5)
      : full_route;

  let q = new Parse.Query("Filter");
  q.matches("url", filter_url);
  let fetchedFilters = await q.find();
  for (const filter of fetchedFilters) {
    await filter.destroy();
  }
  if (fetchedFilters.length != 0)
    Vue.prototype.g_newActivity({
      label_english: payload.get("label_english"),
      label_pashto: payload.get("label_pashto"),
      label_dari: payload.get("label_dari"),
      type: type,
      action: "deleteFilters",
      url: full_route,
      to: null,
      class: "Filter",
      category: activity_category,
      department: payload.get("department"),
      reference_id: payload.get("form").id
    });
  // store.dispatch("fetchSidebarReports");
};

async function deleteActivities(payload) {
  var q = new Parse.Query("Activity");
  q.matches(
    "url",
    store.state.shared.router.currentRoute.path +
      "/" +
      payload.get("class_name").slice(5) +
      "/list"
  );
  let fetchedActivities = await q.find();

  for (const activity of fetchedActivities) {
    await activity.destroy();
  }
}

// this may be useful for later dont delete it
Vue.prototype.delete_this_user_notifications = async function(
  related_object,
  section,
  user
) {
  if (related_object && user) {
    var q = new Parse.Query("Activity");
    q.equalTo("reference_id", related_object.id);
    q.equalTo("section", section);
    q.equalTo("to", user);
    var result = await q.find();
    if (result) {
      for (let i = 0; i < result.length; i++) {
        const activity = result[i];
        if (activity) {
          await activity.destroy();
        }
      }
    }
  }
};

Vue.prototype.delete_category_content = async function(category, section) {
  var class_name = "";
  if (section == "survey") {
    class_name = "Form";
  } else if (section == "article" || section == "file" || section == "map") {
    class_name = section.charAt(0).toUpperCase() + section.slice(1);
    // q.include("meta_form_layout");
  }

  var q = new Parse.Query(class_name);
  q.equalTo("category", category);
  var result = await q.find();
  if (result) {
    for (let i = 0; i < result.length; i++) {
      const entity = result[i];
      if (entity) {
        if (class_name == "Form") {
          // while deleting category, you have to delete all survey that are not pending (delete submissions of each survey & delete submisssion class for that survey)
          // 1. delete submissions
          if (entity.get("status") != "pending") {
            await Vue.prototype.delete_submissions(entity, section);
            await Vue.prototype.delete_submission_class(entity, section);
          }
        } else if (
          class_name == "Article" ||
          class_name == "File" ||
          class_name == "Map"
        ) {
          // delete meta form's submissions if available

          if (entity.get("meta_form_layout")) {
            // meta forms has been attached to this entity
            await Vue.prototype.delete_meta_form_submission(entity);
          }
        }
        await entity.destroy();
      }
    }
  }
};

Vue.prototype.delete_meta_form_submission = async function(object, section) {
  if (
    object &&
    object.get("meta_form_layout") &&
    object.get("meta_form_layout").get("class_name")
  ) {
    var id = "";
    if (object.get("meta_form_english")) {
      id = object.get("meta_form_english");
    } else if (object.get("meta_form_pashto")) {
      id = object.get("meta_form_pashto");
    } else if (object.get("meta_form_dari")) {
      id = object.get("meta_form_dari");
    }

    if (id) {
      var q = new Parse.Query(object.get("meta_form_layout").get("class_name"));
      q.equalTo("objectId", id);
      var result = await q.first();
      if (result) {
        await result.destroy();
      }
    }
  }
};

// category filters
Vue.prototype.delete_category_filters = async function(category, section) {
  var q = new Parse.Query("Filter");
  q.equalTo("category", category);
  var result = await q.find();
  if (result) {
    for (let i = 0; i < result.length; i++) {
      const filter = result[i];
      if (filter) await filter.destroy();
    }
  }
};

// category activities
Vue.prototype.delete_category_activities = async function(category, section) {
  var q = new Parse.Query("Activity");
  q.equalTo("category", category);
  var result = await q.find();
  if (result) {
    for (let i = 0; i < result.length; i++) {
      const activity = result[i];
      if (activity) await activity.destroy().then(res => {});
    }
  }
};

// delete submissions
Vue.prototype.delete_submissions = async function(object, section) {
  if (object && object.get("class_name")) {
    var q = new Parse.Query(object.get("class_name"));
    q.equalTo("form", object);
    q.equalTo("category", object.get("category"));
    q.equalTo("department", object.get("department"));
    var result = await q.find();
    if (result) {
      for (let i = 0; i < result.length; i++) {
        const submission = result[i];
        if (submission) await submission.destroy();
      }
    }
  }
};

// delete submission class
Vue.prototype.delete_submission_class = async function(object, section) {
  if (object && object.get("class_name")) {
    var q = new Parse.Query(object.get("class_name"));
    q.equalTo("form", object);
    q.equalTo("category", object.get("category"));
    q.equalTo("department", object.get("department"));
    var result = await q.first();
    if (!result) {
      await axios
        .post(
          "https://parse.nepa.gov.af/parse/schemas/" + object.get("class_name"),
          {
            _method: "DELETE",
            _ApplicationId: "nepa",
            _ClientVersion: "js1.9.2",
            _MasterKey: "ag33israr3698",
            _InstallationId: "d6a4df62-4f17-1186-871e-6fdff29eed80"
          }
        )
        .then(deleted => {})
        .catch(myError => {});
    } else {
      var self = this;
      self.$notify({
        group: "foo",
        text: self._(payload.className + "submission class was not deleted"),
        duration: 4000,
        position: "top left",
        type: "warn"
      });
    }
  }
};

// delete section activities
Vue.prototype.delete_section_activities = async function(object, section) {
  var q = new Parse.Query("Activity");
  if (object.className == "Filter") {
    q.equalTo("url", object.get("url"));
  } else {
    q.equalTo("reference_id", object.id);
  }
  q.equalTo("category", object.get("category"));
  q.equalTo("department", object.get("department"));
  var result = await q.find();
  if (result) {
    for (let i = 0; i < result.length; i++) {
      const activity = result[i];
      if (activity) await activity.destroy().then(res => {});
    }
  }
};

// delete section filters
Vue.prototype.delete_section_filters = async function(object, section) {
  var q = new Parse.Query("Filter");
  if (section == "survey") q.equalTo("form", object);
  q.equalTo("category", object.get("category"));
  q.equalTo("department", object.get("department"));
  var result = await q.find();
  if (result) {
    for (let i = 0; i < result.length; i++) {
      const filter = result[i];
      if (filter) await filter.destroy();
    }
  }
};

Vue.prototype.delete_section_object_meta_form_references = async function(
  meta_form,
  section
) {
  if (meta_form && section) {
    var class_name = section.charAt(0).toUpperCase() + section.slice(1);
    var q = new Parse.Query(class_name);
    q.equalTo("meta_form_layout", meta_form);
    var result = await q.find();
    if (result) {
      for (let i = 0; i < result.length; i++) {
        const object = result[i];
        object.set("meta_form_layout", null);
        object.set("meta_form_english", null);
        object.set("meta_form_pashto", null);
        object.set("meta_form_dari", null);
        await object
          .save()
          .then(res => {})
          .catch(e => {});
      }
    }
  }
};

Vue.prototype.delete_dependencies = async function(payload, section) {
  if (payload.className == "Category") {
    await Vue.prototype.delete_category_content(payload, section);
    await Vue.prototype.delete_category_filters(payload, section);
    await Vue.prototype.delete_category_activities(payload, section);
  } else if (payload.className == "Form") {
    if (payload.get("is_meta_form")) {
      await Vue.prototype.delete_section_object_meta_form_references(
        payload,
        section
      );
      await Vue.prototype.delete_submissions(payload, section);
      await Vue.prototype.delete_submission_class(payload, section);
    } else if (!payload.get("is_meta_form")) {
      if (payload.get("status") != "pending") {
        await Vue.prototype.delete_submissions(payload, section);
        await Vue.prototype.delete_submission_class(payload, section);
      }
      await Vue.prototype.delete_section_activities(payload, section);
      await Vue.prototype.delete_section_filters(payload, section);
    }
  } else if (
    payload.className == "Article" ||
    payload.className == "File" ||
    payload.className == "Map"
  ) {
    await Vue.prototype.delete_meta_form_submission(payload, section);
    await Vue.prototype.delete_section_activities(payload, section);
  } else if (payload.className == "Filter") {
    await Vue.prototype.delete_section_activities(payload, section);
  }
};

Vue.prototype.g_deleteObject = async function(payload) {
  // for now, only survey, article, file, map, category meta-form and filter can be delete.
  // department and user deletion is also a plan

  if (payload) {
    // payload is the parse object
    // start of initialization
    var self = this;
    let full_route = store.state.shared.router.currentRoute.path;
    let route_name = store.state.shared.router.currentRoute.matched[0].name;
    let section = route_name.substring(0, route_name.length - 1);
    let activity_category;
    let activity_department;
    let activity_type;

    // set activity category
    if (payload.className == "Category") {
      activity_category = payload;
    } else if (
      payload.className == "Form" ||
      payload.className == "Article" ||
      payload.className == "File" ||
      payload.className == "Map" ||
      payload.className == "Filter"
    ) {
      activity_category = payload.get("category");
    }

    // set activity department & type
    if (
      payload.className == "Form" ||
      payload.className == "Article" ||
      payload.className == "File" ||
      payload.className == "Map" ||
      payload.className == "Category" ||
      payload.className == "Filter"
    ) {
      activity_department = payload.get("department");
      activity_type = section;
    } else {
      activity_type = payload.className.toLowerCase();
    }
    // end of initialization

    return new Promise((resolve, reject) => {
      self.VaModal.confirm({
        title: self._("Alert"),
        message: self._(
          "Please make sure if you want to delete this " +
            payload.className.toLowerCase()
        ),
        type: "warning",

        async onConfirm() {
          self.$store.commit("setLoading", true);
          // dependencies deletion -------------------------------------------------------
          await Vue.prototype.delete_dependencies(payload, section);

          await payload
            .destroy()
            .then(async removed_object => {
              await Vue.prototype.g_newActivity({
                label_english: payload.get("label_english"),
                label_pashto: payload.get("label_pashto"),
                label_dari: payload.get("label_dari"),
                type: activity_type,
                action: "delete",
                url: full_route,
                to: null,
                class: payload.className,
                category: activity_category,
                department: activity_department,
                reference_id: payload.id
              });
              self.$notify({
                group: "foo",
                text: self._(payload.className + " was deleted"),
                duration: 4000,
                position: "top left",
                type: "warn"
              });
              self.$store.commit("setLoading", false);
              resolve(true);
            })
            .catch(error => {
              reject(false);
              self.$store.commit("setLoading", false);
              self.$notify({
                group: "foo",
                title: self._("System Error"),
                text: self._("An error was occurred"),
                duration: 4000,
                position: "top left",
                type: "warn"
              });
            });
        }
      });
    });
  }
};

Vue.prototype.g_newActivity = async function(payload) {
  let Activity = new Parse.Object.extend("Activity");
  let newActivity = new Activity();
  let activity = {
    label_english: payload.label_english,
    label_pashto: payload.label_pashto,
    label_dari: payload.label_dari,
    previous_label_english: payload.previous_label_english,
    previous_label_pashto: payload.previous_label_pashto,
    previous_label_dari: payload.previous_label_dari,
    type: payload.type,
    action: payload.action,
    url: payload.url,
    createdBy: store.state.auth.user,
    to: payload.to,
    category: payload.category,
    department: payload.department,
    class: payload.class,
    is_comment: false,
    seen: false,
    reference_id: payload.reference_id
  };

  newActivity
    .save(activity)
    .then(inserted => {})

    .catch(e => {});
};

Vue.prototype.g_userRenderer = function(user) {
  return `<div style="display: flex; flex-direction: row" >
  <img width="45px" height="45px" src="${user
    .get("profilePic")
    .replace(
      "https://parse.nepa.gov.af/parse/files/nepa/",
      "https://parse.nepa.gov.af/parse/files/nepa/thumbnail_"
    )}" style="margin-right: 10px; border-radius: 100px"/>
                            <span style="display: flex; flex-direction: column">
                                <span >${user.get("name")}</span>
                                <span style="color: gray">${user.get(
                                  "username"
                                )}</span>
                              </span>
                        </div>`;
};

Vue.prototype.g_getActivityAction = function(activity) {
  let to;
  if (activity.get("to") && store.getters.user.id == activity.get("to").id)
    to = this._("you");
  else if (activity.get("to")) to = activity.get("to").get("name");

  let action = activity.get("action");
  let text = this.$route.params.id ? " this " : this.g_getLabel(activity);
  let filterType =
    activity.get("class") == "Filter" ? " report " : activity.get("type");
  if (action == "create")
    return this._("created") + " " + this._(text) + " " + this._(filterType);
  else if (action == "edit")
    return this._("updated") + " " + this._(text) + " " + this._(filterType);
  else if (action == "delete")
    return this._("deleted") + " " + this._(text) + " " + this._(filterType);
  // else if (action == 'approvalAssignment') return 'assigned ' + activity.get('to').get('name') + ' to ' + text + ' ' + activity.get('type') + ' as an approver'
  else if (action == "approverAdd")
    return (
      this._("assigned new approvers to") +
      " " +
      this.g_getLabel(activity) +
      " " +
      this._(activity.get("type"))
    );
  else if (action == "submissionApproverAdd")
    return (
      this._("assigned new submissoin approvers to") +
      " " +
      this.g_getLabel(activity) +
      " " +
      this._(activity.get("type"))
    );
  else if (action == "activateUser")
    return (
      this._("activated ") +
      " " +
      this.g_getLabel(activity) +
      " " +
      this._(activity.get("type"))
    );
  else if (action == "deactivateUser")
    return (
      this._("deactivated ") +
      " " +
      this.g_getLabel(activity) +
      " " +
      this._(activity.get("type"))
    );
  else if (action == "approvalAssignment" && activity.get("to") != null)
    return (
      this._("assigned") +
      " " +
      to +
      " " +
      this._("to") +
      " " +
      this.g_getLabel(activity) +
      " " +
      this._(activity.get("type")) +
      " " +
      this._("as approver")
    );
  else if (action == "designApproverAdd")
    return (
      "assigned new approvers to " +
      this.g_getLabel(activity) +
      " " +
      this._(activity.get("type"))
    );
  else if (action == "designApprovalAssignment" && activity.get("to") != null)
    return (
      this._("assigned") +
      " " +
      to +
      " to " +
      this.g_getLabel(activity) +
      " " +
      this._(activity.get("type")) +
      " " +
      this._("as form design approver")
    );
  else if (action == "updateCategory")
    return (
      this._("updated") +
      " " +
      this._("category") +
      " " +
      this._("label from") +
      " " +
      this.getPreviousLabel(activity) +
      " " +
      this._("to") +
      " " +
      this.g_getLabel(activity)
    );
  else if (action == "editLabel")
    return (
      this._("updated") +
      " " +
      this._(activity.get("type")) +
      " " +
      this._("label") +
      " " +
      this._("from") +
      " " +
      this.getPreviousLabel(activity) +
      " " +
      this._("to") +
      " " +
      this.g_getLabel(activity)
    );
  else if (action == "publishSurvey")
    return (
      this._("published") +
      " " +
      this.g_getLabel(activity) +
      " " +
      this._(activity.get("type"))
    );
  else if (action == "approve" && activity.get("class").includes("Data_"))
    return (
      _("approved") +
      " " +
      this.g_getLabel(activity) +
      " " +
      this._(activity.get("type")) +
      this._("'s submission") +
      " " +
      this._("of") +
      " " +
      to
    );
  else if (action == "approve")
    return (
      _("approved") +
      " " +
      this.g_getLabel(activity) +
      " " +
      this._(activity.get("type"))
    );
  else if (action == "reject" && activity.get("class").includes("Data_"))
    return (
      this._("rejected") +
      " " +
      this.g_getLabel(activity) +
      " " +
      this._(activity.get("type")) +
      "'s submission" +
      " " +
      this._("of") +
      " " +
      to
    );
  else if (action == "reject")
    return (
      this._("rejected") +
      " " +
      this.g_getLabel(activity) +
      " " +
      this._(activity.get("type"))
    );
  else if (action == "approvalAssignment" && activity.get("to") != null)
    return (
      this._("assigned") +
      " " +
      to +
      " " +
      this._("to") +
      " " +
      this.g_getLabel(activity) +
      " " +
      this._(activity.get("type")) +
      " " +
      this._("as a submitter")
    );
  else if (action == "publishDesignSurvey" && activity.get("to") != null)
    return (
      this._("published") +
      " " +
      this.g_getLabel(activity) +
      " " +
      this._(activity.get("type")) +
      " " +
      this._(" you designed")
    );
  else if (action == "approvalAssignment")
    return (
      _("approved") +
      " " +
      this.g_getLabel(activity) +
      " " +
      this._(activity.get("type"))
    );
  else if (action == "newSubmission" && activity.get("createdBy") != null)
    return (
      activity.get("createdBy").get("name") +
      " " +
      this._("submitted new entry in") +
      " " +
      this.g_getLabel(activity) +
      " " +
      this._(activity.get("type"))
    );
  else if (action == "resumeSurvey")
    return (
      this._("resumed") +
      " " +
      this.g_getLabel(activity) +
      " " +
      this._(activity.get("type"))
    );
  else if (action == "pauseSurvey")
    return (
      this._("paused") +
      " " +
      this.g_getLabel(activity) +
      " " +
      this._(activity.get("type"))
    );
  else if (action == "completeSurvey")
    return (
      this._("makerd") +
      " " +
      this.g_getLabel(activity) +
      " " +
      this._(activity.get("type")) +
      " " +
      this._("as compelted")
    );
  else if (action == "submitterAdd")
    return (
      this._("Added new submitters to") +
      " " +
      this.g_getLabel(activity) +
      " " +
      this._(activity.get("type"))
    );
  else if (action == "submissionApproverAdd")
    return (
      this._("added new submisison approvers to") +
      " " +
      this.g_getLabel(activity) +
      " " +
      this._(activity.get("type"))
    );
  else if (action == "designApproverRemove")
    return (
      this._("removed some design approvers from") +
      " " +
      this.g_getLabel(activity) +
      " " +
      this._(activity.get("type"))
    );
  else if (action == "editSidebar")
    return (
      this._("paused") +
      " " +
      this.g_getLabel(activity) +
      " " +
      this._(activity.get("type"))
    );
  else if (action == "editFormLanguage")
    return (
      this._("updated") +
      " " +
      this.g_getLabel(activity) +
      " " +
      this._(activity.get("type")) +
      " " +
      this._("languages")
    );
  else if (action == "editFormProvince")
    return (
      this._("updated") +
      " " +
      this.g_getLabel(activity) +
      " " +
      this._(activity.get("type")) +
      " " +
      this._("provinces")
    );
  // needs thinking
  else if (action == "publishApprovedDesign")
    return (
      this._("published your form design for") +
      " <strong>" +
      this.g_getLabel(activity) +
      "</strong> " +
      this._(activity.get("type"))
    );
  else if (action == "deleteFilters")
    return (
      this._("deleted") +
      " " +
      this.g_getLabel(activity) +
      "'s filters by deleting the survey"
    );
  else if (action == "deleteSubmissions")
    return (
      this._("deleted") +
      " " +
      this.g_getLabel(activity) +
      " " +
      this._(activity.get("type")) +
      "'s submissions by deleting the survey"
    );
  else if (action == "createCategory")
    return (
      this._("created") +
      " " +
      this.g_getLabel(activity) +
      " " +
      this._("category")
    );
  else if (action == "deleteCategory")
    return (
      this._("deleted") +
      " " +
      this.g_getLabel(activity) +
      " " +
      this._("category")
    );
  else if (action == "editFilter")
    return (
      this._("updated") +
      " " +
      this.g_getLabel(activity) +
      " " +
      this._("filter")
    );
  else if (action == "createFilter")
    return (
      this._("created") +
      " " +
      this.g_getLabel(activity) +
      " " +
      this._("filter")
    );
  else if (action == "createMetaForm")
    return (
      this._("created") +
      " " +
      this.g_getLabel(activity) +
      " " +
      this._("meta form")
    );
  else if (action == "deleteActivities")
    return (
      this._("deleted") +
      " " +
      this.g_getLabel(activity) +
      "'s filters by delete the survey"
    );
  else if (action == "PublishApprovalBy" && activity.get("to"))
    return (
      this._("published") +
      " " +
      this.g_getLabel(activity) +
      " " +
      this._(activity.get("type")) +
      " that " +
      to +
      " " +
      this._("has approved")
    );
  else if (action == "submitterAssignment" && activity.get("to"))
    return (
      this._("assigned") +
      " " +
      to +
      " " +
      this._("as") +
      " " +
      this.g_getLabel(activity) +
      " " +
      this._(activity.get("type")) +
      " " +
      this._("submitter")
    );
  else if (action == "deleteFilters")
    return (
      this._("deleted") +
      " " +
      this.g_getLabel(activity) +
      "'s filters by delete the survey"
    );
  else if (action == "deleteFilters")
    return (
      this._("deleted") +
      " " +
      this.g_getLabel(activity) +
      "'s filters by delete the survey"
    );
  else if (action == "deleteFilters")
    return (
      this._("deleted") +
      " " +
      this.g_getLabel(activity) +
      "'s filters by delete the survey"
    );
  // XAcmnZRwIn = realManager@gmail.com,  FCDXDgAsTk = ahmad@gmail.com
  else if (action == "approverRemove")
    return (
      this._("removed some approvers from") +
      " " +
      this.g_getLabel(activity) +
      " " +
      this._(activity.get("type"))
    );
  else if (action == "attachmentUpload")
    return (
      this._("uploaded some extra attachments to") +
      " " +
      this.g_getLabel(activity) +
      " " +
      this._(activity.get("type"))
    );
  else if (action == "shareWithGuest")
    return this._(
      "shared" +
        " " +
        this.g_getLabel(activity) +
        " " +
        activity.get("type") +
        " " +
        "with" +
        " " +
        to
    );
  else if (action == "attachmentRemove")
    return (
      this._("removed some attachments from") +
      " " +
      this.g_getLabel(activity) +
      " " +
      this._(activity.get("type"))
    );
  else return this._("action text");
};
